import {useInterventionStore} from '@/ts/store/intervention-store';
import {type UseInterventionRes, useProvidedIntervention} from '@/ts/composables/pure/use-provided-intervention';

/** Provides computed intervention data (current session, progress) from the injected intervention store */
export function useIntervention(): UseInterventionRes {
  const intervention = useInterventionStore();
  return useProvidedIntervention(intervention);
}

